<template>
  <v-card class="lean-list-item-card">
    <v-system-bar lights-out>
      <lean-list-item-checkbox :record="record" />
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-system-bar>
    <v-img v-if="image" :src="image" class="justify-center" :aspect-ratio="16 / 9">
      <div v-if="video && showVideo">
        <video class="lean-list-item-card-video" :src="video" controls />
      </div>
      <v-row v-else-if="video" class="fill-height ma-0" align="center" justify="center">
        <v-btn icon dark x-large @click="showVideo = true">
          <v-icon v-if="video">mdi-play</v-icon>
        </v-btn>
      </v-row>
    </v-img>
    <v-list-item three-line @click="$emit('click')">
      <v-list-item-content class="lean-list-item-content">
        <v-list-item-title v-html="title"></v-list-item-title>
        <v-list-item-subtitle v-html="subtitle"></v-list-item-subtitle>
        <v-list-item-subtitle v-html="subtitle2"></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import listItemMixin from '@/mixins/LeanListItem';
import LeanListItemCheckbox from '@/components/LeanListItemCheckbox';

export default {
  name: 'LeanListItemCard',
  mixins: [listItemMixin],
  components: { LeanListItemCheckbox }
};
</script>

<style lang="scss">
.lean-list-item-card-video {
  display: block;
  height: 100%;
  width: 100%;
}
.lean-list-item-card .lean-list-item-checkbox.v-input--selection-controls {
  margin-top: 0;
}
</style>
